import { useState } from "react";
import {useTranslation, withTranslation} from "react-i18next";

import Tooltip from "@mui/material/Tooltip"
import { Box } from "@mui/material";
import dateUtils from "@plannel/utils/date-util";
import Slider from "@mui/material/Slider";
import {isEqual} from "lodash";

const SALES = "SALES";
const DEMAND = "DEMAND";

const RpPeriodSlider = ({ planStartDate, salesPeriodRef, demandPeriodRef, onChangeSliderValueHandler, isOnlySlider = false }) => {
  const { t } = useTranslation();
  const fieldSetStyle = { borderColor: "#eeeeee", borderStyle: "solid", borderRadius: "2%", width: "inherit" };
  const sliderMarks = [
    { value: -12, label: '-12' }, { value: -9, label: '-9' }, { value: -6, label: '-6' }, { value: -3, label: '-3' }, { value: 0, label: '0' },
    { value: 3, label: '3' }, { value: 6, label: '6' }, { value: 9, label: '9' }, { value: 12, label: '12' }
  ];
  const [salesPeriod, setSalesPeriod] = useState(salesPeriodRef);
  const [demandPeriod, setDemandPeriod] = useState(demandPeriodRef);

  const salesPeriodLabelComponent = (props) => {
    const { children, value } = props;
    if (planStartDate === null) {
      return (
        <Tooltip enterTouchDelay={0} placement="top">
          {children}
        </Tooltip>);
    }
    const baseDate = new ZDate(planStartDate);

    if (props.index === 0) {
      baseDate.setMonth(baseDate.getMonth() + value);
    } else {
      baseDate.setMonth(baseDate.getMonth() + value);
      baseDate.setDate(baseDate.getDate() - 1);
    }

    return (
      <Tooltip enterTouchDelay={0} placement="top" title={`${dateUtils.formatDate(baseDate, "yyyy-MM-dd")}`}>
        {children}
      </Tooltip>
    );
  }

  const demandPeriodLabelComponent = (props) => {
    const { children, value } = props;
    if (planStartDate === null) {
      return (
        <Tooltip enterTouchDelay={0} placement="top">
        {children}
      </Tooltip>);
    }
    const baseDate = new ZDate(planStartDate);

    if (props.index === 0) {
      baseDate.setMonth(baseDate.getMonth() + value);
    } else {
      baseDate.setMonth(baseDate.getMonth() + value);
      if (value !== 0) {
        baseDate.setDate(baseDate.getDate() - 1);
      }
    }

    return (
      <Tooltip enterTouchDelay={0} placement="top" title={`${dateUtils.formatDate(baseDate, "yyyy-MM-dd")}`}>
        {children}
      </Tooltip>
    );
  }

  const onChange = (_, newValue, type) => {
    if (isEqual(type, SALES)) {
      setSalesPeriod([newValue[0], newValue[1]]);
    } else if (isEqual(type, DEMAND)) {
      setDemandPeriod([newValue[0], newValue[1]]);
    }
  };

  return (
    isOnlySlider ? (
        <Box sx={{ display: "flex", mt: 1 }}>
          <Slider
            value={salesPeriod}
            onChange={(_, newValue) => onChange(_, newValue, SALES)}
            onChangeCommitted={(_, newValue) => onChangeSliderValueHandler(_, newValue, SALES)}
            valueLabelDisplay="auto"
            step={1}
            slots={{
              valueLabel: salesPeriodLabelComponent,
            }}
            marks={sliderMarks}
            min={-12}
            max={0}
            sx={{ mr: 2 }}
          />
          <Slider
            value={demandPeriod}
            onChange={(_, newValue) => onChange(_, newValue, DEMAND)}
            onChangeCommitted={(_, newValue) => onChangeSliderValueHandler(_, newValue, DEMAND)}
            valueLabelDisplay="auto"
            step={1}
            slots={{
              valueLabel: demandPeriodLabelComponent,
            }}
            marks={sliderMarks}
            min={0}
            max={12}
            sx={{ ml: 2 }}
          />
        </Box>)
    :
      (<Box>
          <Box component={"fieldset"} sx={fieldSetStyle}>
            <Box component={"legend"} mx={0.5}>{t("demandRefPeriodForAvgSales")}</Box>
            <Box sx={{ display: "flex", mt: 1 }}>
              <Slider
                value={salesPeriodRef}
                onChange={(_, newValue) => onChangeSliderValueHandler(_, newValue, SALES)}
                valueLabelDisplay="auto"
                step={1}
                slots={{
                  valueLabel: salesPeriodLabelComponent,
                }}
                marks={sliderMarks}
                min={-12}
                max={0}
                sx={{ mr: 2 }}
              />
              <Slider
                value={demandPeriodRef}
                onChange={(_, newValue) => onChangeSliderValueHandler(_, newValue, DEMAND)}
                valueLabelDisplay="auto"
                step={1}
                slots={{
                  valueLabel: demandPeriodLabelComponent,
                }}
                marks={sliderMarks}
                min={0}
                max={12}
                sx={{ ml: 2 }}
              />
            </Box>
          </Box>
        </Box> )
  );
}
export default withTranslation()(RpPeriodSlider);